import type { CreatableProtocol, IconicProtocol, PermissionProtocol, QuotaProtocols } from '../protocols'
import type { BaseApplicationAbstract } from './Application'

/** 注意：该数组的index与SpaceVersionCode 匹配， 修改时请注意  - start */
export enum SpaceVersion {
    FREE = 'FREE',
    BASIC = 'BASIC',
    STANDARD = 'STANDARD',
    ADVANCED = 'ADVANCED',
    PROFESSIONAL = 'PROFESSIONAL',
    ENTERPRISE = 'ENTERPRISE',
    ULTIMATE = 'ULTIMATE'
}

export const spaceByeCodeVersion = [
    SpaceVersion.FREE,
    SpaceVersion.BASIC,
    SpaceVersion.STANDARD,
    SpaceVersion.ADVANCED,
    SpaceVersion.PROFESSIONAL,
    SpaceVersion.ENTERPRISE,
    SpaceVersion.ULTIMATE
] as const

/* * 注意：该数组的index与SpaceVersionCode 匹配， 修改时请注意  - end */

export const MaxVersionLevel = spaceByeCodeVersion.length - 1

export type SpaceVersionCode = 0 | 1 | 2 | 3 | 4 | 5 | 6
export abstract class WorkSpaceAbstract implements IconicProtocol, CreatableProtocol, PermissionProtocol {
    abstract id: string

    abstract name: string

    abstract icon: string

    abstract members: number

    abstract applications: BaseApplicationAbstract[]

    abstract version?: SpaceVersion

    abstract browseStart?: boolean

    abstract createdTime?: number

    abstract updatedTime?: number

    abstract createdBy?: string

    abstract updatedBy?: string

    abstract expiredAt?: number

    abstract roleId?: string

    abstract apiKey?: string
}

export type SpaceQuota = {
    spaceName: string
    currentVersion: SpaceVersion
    currentVersionCode?: number
    // -1 为无限制 默认为到期时间戳
    expiredAt: number
    // numberOfApps: QuotaProtocols
    // numberOfWorkflowExecutions: QuotaProtocols
    // numberOfAiInvocation: QuotaProtocols
    fileStorage: QuotaProtocols
    numberOfRecords: QuotaProtocols
    numberOfUsers: QuotaProtocols
    numberOfDomain: QuotaProtocols
    numberOfUv: QuotaProtocols
    // 更新次数
    numberOfUpdates: QuotaProtocols
    // 数据表查询算力
    numberOfCu: QuotaProtocols
    // 可发布应用数量
    numberOfPublishedApps: QuotaProtocols
    // 用户阿里云视频用量

    traffic: {
        // 新增
        packs: (QuotaProtocols & {
            startTime: number // 13位时间戳 开始时间
            expiredAt?: number // 13位时间戳 过期时间， 如果没有过期时间则表示永久有效，
            // 流量类型，INCLUDE代表版本内置流量，PURCHASED 代表增购流量
            packType: 'INCLUDE' | 'PURCHASED'
        })[]
    } & QuotaProtocols
    // api执行次数
    apiInvoke: QuotaProtocols
    sms: QuotaProtocols
    llmToken: QuotaProtocols
    embeddingToken: QuotaProtocols
}
